module.exports = __webpack_public_path__ + "fonts/SFCompactDisplay-Thin.5c3149d.otf";